import { useState, useEffect, useCallback } from "react";
import useDebounce from "./useDebounce";
import { PaginationState } from "@tanstack/react-table";

const usePagination = () => {
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 5,
  });
  const { handleSearch, debouncedValue, searchTerm, resetSearch } =
    useDebounce(300);

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }));
  }, [debouncedValue]);

  const goToPage = useCallback(
    (page: number) => {
      if (page >= 0 && page < totalPages) {
        // Adjusted to 0-based indexing
        setPagination((prev) => ({
          ...prev,
          pageIndex: page,
        }));
      }
    },
    [totalPages],
  );

  const handleTotalPages = useCallback((pages: number) => {
    setTotalPages(pages);
  }, []);

  const handleTotalItems = useCallback((items: number) => {
    setTotalItems(items);
  }, []);

  return {
    goToPage,
    totalPages,
    totalItems,
    handleTotalPages,
    handleTotalItems,
    debouncedValue: debouncedValue?.trim() !== "" ? debouncedValue : undefined,
    handleSearch,
    searchTerm,
    pagination,
    setPagination,
    resetSearch,
  };
};

export default usePagination;
